import React, { useContext } from 'react'
import { GVarState } from '../StoreState/Gstate';


function IconeWithText({ text, d, distance, i }) {

  let g = useContext(GVarState);
  if (g.StapeByStape[i - 1]?.type === "Elevator") {
    return
  }
  return (
    <div
      key={i}
      style={{
        display: "flex",
        alignItems: "center",
        // width: "300px",
        padding: "2px",
        borderBottom: "1px solid gray"
      }}
    >
      <span
        style={{
          padding: "10px",
          borderRadius: "50%",
          // backgroundColor: !d?.done ? "green" : "red",
          width: "40px",
          height: "40px",
        }}
      >
        {d?.turn === "right" && <img src="/rlwd/right.svg" />}
        {d?.turn === "left" && <img src="/rlwd/left.svg" />}
        {d?.done === "ok" && <img src="/rlwd/ok.svg" />}
        {d?.type === "Elevator" && d?.turn == "Next Floor" && <img src="/rlwd/elevator-icon.svg" />}
        {d?.type === "Escalator" && d?.turn == "Next Floor" && <img src="/rlwd/Escalator.svg" />}
        
      </span>
      <div>
        <p
          style={{
            padding: "10px 10px 0px 10px",
            fontSize: "12px",
            fontFamily: "serif",
            fontWeight: "900",
          }}
        >
          {text}
        </p>
        <p
          style={{
            padding: "0px 10px 0px 10px",
            fontSize: "12px",
            fontFamily: "serif",
            fontWeight: "900",
          }}
        >
          {d.next == "Up" || d.next == "Down" ? "" : distance}

        </p>
      </div>
    </div>
  );
}


export default IconeWithText